import { useModules } from 'api/modules/modules.api'
import { useActiveSystemIsSettled } from 'api/systems/systems.api'
import { useMainRoutes } from 'routes/main.routes'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { RoutesArray } from 'ui/components/Navigation/types'
import { filterRoutes } from './MainLayout.utils'

/** Returns the routes for the active system, or `undefined` until the active system has settled. */
export function useActiveSystemRoutes(): RoutesArray | undefined {
  const { systemId } = useAuth()
  const { data: modules = [] } = useModules(systemId)
  const activeSystemIsSettled = useActiveSystemIsSettled()
  const mainRoutes = useMainRoutes()

  if (!activeSystemIsSettled) {
    return undefined
  }
  return filterRoutes(mainRoutes, modules)
}
